module.exports = __webpack_public_path__ + "img/review.6ed34699.png";